"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var formik_1 = require("formik");
function SelectField(props) {
    var name = props.name, label = props.label;
    var disableFormik = props.disableFormik, errorMessage = props.errorMessage, propsRest = __rest(props, ["disableFormik", "errorMessage"]);
    var _a = __read((0, formik_1.useField)(name), 1), field = _a[0];
    return ((0, jsx_runtime_1.jsxs)(material_1.FormControl, __assign({ fullWidth: true, error: !!errorMessage }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", spacing: 0.5 }, { children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, __assign({ htmlFor: name, sx: {
                            textTransform: 'uppercase',
                            transform: 'none',
                            fontSize: '0.86rem',
                            color: '#9da8b3',
                            pl: 0.5,
                            '&:not(.Mui-error).Mui-focused': {
                                color: '#9ea3f2',
                            },
                            position: 'relative',
                            lineHeight: '1.66',
                        } }, { children: label })), errorMessage && (0, jsx_runtime_1.jsxs)(material_1.FormHelperText, { children: ["- ", errorMessage] })] })), (0, jsx_runtime_1.jsx)(material_1.Select, __assign({ id: name, sx: {
                    'label + &': {
                        marginTop: function (theme) { return theme.spacing(2.5); },
                    },
                    '& .MuiInputBase-input': {
                        borderRadius: 2,
                        position: 'relative',
                        backgroundColor: 'secondary.dark',
                        border: '1px solid',
                        borderColor: 'secondary.light',
                        py: 2,
                        px: 2.5,
                        transition: function (theme) { return theme.transitions.create(['border-color']); },
                        ':not(.Mui-error) &:focus': {
                            borderColor: '#9ea3f2',
                        },
                    },
                    '& fieldset': {
                        display: 'none',
                    },
                } }, propsRest, (disableFormik ? {} : field)))] })));
}
exports.default = SelectField;
SelectField.defaultProps = {
    disableFormik: false,
    errorMessage: undefined,
};
//# sourceMappingURL=SelectField.js.map